module.exports = __webpack_public_path__ + "static/img/home_today_amount.68547a5a.png";